import { render, staticRenderFns } from "./FormControlDangerTooltip.vue?vue&type=template&id=4ecb33c0"
import script from "./FormControlDangerTooltip.vue?vue&type=script&lang=js"
export * from "./FormControlDangerTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports